import { moduleProviderFactory } from 'core/providers';
import { DiagnosisCodeList, DiagnosisCodeEdit } from 'application/diagnosis-code/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.diagnosis-code',
                pattern: '/diagnosis-code',
                children: [
                    {
                        name: 'master.app.main.diagnosis-code.list',
                        pattern: '',
                        tabTitle: 'DIAGNOSIS_CODE.LIST.TITLE',
                        component: DiagnosisCodeList,
                        data: {
                            title: 'DIAGNOSIS_CODE.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.diagnosis-code.create',
                        pattern: '/create',
                        tabTitle: 'DIAGNOSIS_CODE.CREATE.TITLE',
                        component: DiagnosisCodeEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'DIAGNOSIS_CODE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.diagnosis-code.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'DIAGNOSIS_CODE.EDIT.TITLE',
                        component: DiagnosisCodeEdit,
                        data: {
                            title: 'DIAGNOSIS_CODE.EDIT.TITLE'
                        },
                    } 
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.DIAGNOSIS_CODES',
                        route: 'master.app.main.diagnosis-code.list',
                        order: 2,
                    }                    
                ]
            }
        ]
    });
})();

